<template>
  <PSIntegratedOffice />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
